import { render } from "./MollieStatusView.vue?vue&type=template&id=64e67432&scoped=true"
import script from "./MollieStatusView.vue?vue&type=script&lang=js"
export * from "./MollieStatusView.vue?vue&type=script&lang=js"

import "./MollieStatusView.vue?vue&type=style&index=0&id=64e67432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e67432"]])

export default __exports__